export { default as test } from './test.vue'
export { default as root } from './root.vue'
export { default as register } from './register.vue'
export { default as login } from './login.vue'
export { default as courses } from './courses.vue'
export { default as mycourses } from './mycourses.vue'
export { default as coursedetail } from './course-detail.vue'
export { default as profile } from './profile.vue'
export { default as imprint } from './imprint.vue'
export { default as privacy } from './privacy.vue'



// WEBPACK FOOTER //
// ./src/views/index.js